(() => {
  if (customElements.get('gn-memorial-personalizer')) return;
  class MemorialPersonalizer extends HTMLElement {
    connectedCallback() {
      this.form = this.closest('form');
      this.input = this.form?.querySelector('[name="properties[Pet name to print]"]');
      this.canvas = this.querySelector('canvas');
      this.error = this.querySelector('[role="alert"]');
      if (!this.form || !this.input || !this.canvas || !this.error) return;
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.input.addEventListener('input', () => this.draw(), options);
      this.form.addEventListener('reset', () => requestAnimationFrame(() => this.draw()), options);
      this.form.addEventListener('submit', (event) => {
        if (!this.input.checkValidity()) {
          event.preventDefault();
          event.stopImmediatePropagation();
          this.input.reportValidity();
        }
      }, { ...options, capture: true });
      this.image = new Image();
      this.image.crossOrigin = 'anonymous';
      this.image.onload = () => { this.loaded = true; this.draw(); };
      this.image.onerror = () => this.showError(this.dataset.loadError);
      this.image.src = this.dataset.preview;
    }
    disconnectedCallback() { this.controller?.abort(); }
    showError(message) {
      this.error.textContent = message || '';
      this.error.hidden = !message;
    }
    draw() {
      if (!this.loaded || !this.isConnected) return;
      const name = this.input.value.trim();
      const ctx = this.canvas.getContext('2d');
      const width = 2048, height = 1582;
      ctx.clearRect(0, 0, width, height);
      ctx.drawImage(this.image, 0, 0, width, height);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = '#213d24';
      if (name) {
        let size = 112;
        for (; size >= 36; size--) {
          ctx.font = `bold ${size}px Georgia, serif`;
          if (ctx.measureText(name).width <= 700) break;
        }
        if (size < 36) { this.showError(this.dataset.fitError); return; }
        ctx.fillText(name, 1378, 445);
      }
      ctx.save();
      ctx.translate(width / 2, height / 2);
      ctx.rotate(-Math.PI / 6);
      ctx.globalCompositeOperation = 'difference';
      ctx.fillStyle = 'rgba(255, 255, 255, 0.22)';
      ctx.font = '700 246px Arial, sans-serif';
      for (const offset of [-height * .28, 0, height * .28]) {
        ctx.fillText(this.dataset.watermark, 0, offset, width * .7);
      }
      ctx.restore();
      this.canvas.setAttribute('aria-label', this.dataset.label + (name ? ': ' + name : ''));
      this.showError('');
    }
  }
  customElements.define('gn-memorial-personalizer', MemorialPersonalizer);
})();
